import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './sw/serviceWorker';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";


const RootEl = () => (
  <Router>
    <Switch>
      <Route path="/">
        <App/>
      </Route>
    </Switch>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootEl/>);

reportWebVitals();
serviceWorker.register();
